/* eslint-disable react/jsx-key */
import _ from 'lodash-es';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Row } from 'reactstrap';
import { sendCommand } from '../../../actions/atorch';
import { ACMeterPacket, CommandSet, DCMeterPacket, USBMeterPacket } from '../../../service/atorch-packet';
import locals from './index.scss';
import { Report } from './Report';
import { Toolbar } from './Toolbar';
import { FormattedUnit } from './utils';
const CO2Name = (React.createElement("span", null,
    "CO",
    React.createElement("sub", null, "2")));
export const PrintReport = ({ packet }) => {
    var _a;
    const type = (_a = packet === null || packet === void 0 ? void 0 : packet.type) !== null && _a !== void 0 ? _a : 0;
    let record;
    if (packet instanceof ACMeterPacket) {
        record = [
            ['Voltage', React.createElement(FormattedUnit, { value: packet.mVoltage, unit: 'V' })],
            ['Ampere', React.createElement(FormattedUnit, { value: packet.mAmpere, unit: 'A' })],
            ['Watt', React.createElement(FormattedUnit, { value: packet.mWatt, unit: 'W' })],
            ['W·h', React.createElement(FormattedUnit, { value: packet.mWh, unit: 'W\u00B7h' }), React.createElement(Command, { onClick: CommandSet.resetWh.bind(null, type) }, "Reset")],
            [CO2Name, React.createElement(FormattedUnit, { value: getCO2(packet.mWh), unit: 'g' })],
            ['Price', `${packet.price.toFixed(2)} $/kW·h`, React.createElement(SetupPriceCommand, { type: type, value: packet.price })],
            ['Fee', `${packet.fee.toFixed(5)} $`],
            ['Frequency', `${packet.frequency.toFixed(1)} Hz`],
            ['PF', packet.pf.toFixed(2)],
            ['Temperature', React.createElement(FormattedTemperature, { value: packet.temperature })],
            ['Duration', packet.duration],
            ['Backlight Time', React.createElement(FormattedBacklightTime, { time: packet.backlightTime }), React.createElement(SetupBacklightTimeCommand, { type: type, value: packet.backlightTime })],
        ];
    }
    else if (packet instanceof DCMeterPacket) {
        record = [
            ['Voltage', React.createElement(FormattedUnit, { value: packet.mVoltage, unit: 'V' })],
            ['Ampere', React.createElement(FormattedUnit, { value: packet.mAmpere, unit: 'A' })],
            ['Watt', React.createElement(FormattedUnit, { value: packet.mWatt, unit: 'W' })],
            ['W·h', React.createElement(FormattedUnit, { value: packet.mWh, unit: 'W\u00B7h' }), React.createElement(Command, { onClick: CommandSet.resetWh.bind(null, type) }, "Reset")],
            [CO2Name, React.createElement(FormattedUnit, { value: getCO2(packet.mWh), unit: 'g' })],
            ['Price', `${packet.price.toFixed(2)} $/kW·h`, React.createElement(SetupPriceCommand, { type: type, value: packet.price })],
            ['Fee', `${packet.fee.toFixed(5)} $`],
            ['Temperature', React.createElement(FormattedTemperature, { value: packet.temperature })],
            ['Duration', packet.duration],
            ['Backlight Time', React.createElement(FormattedBacklightTime, { time: packet.backlightTime }), React.createElement(SetupBacklightTimeCommand, { type: type, value: packet.backlightTime })],
        ];
    }
    else if (packet instanceof USBMeterPacket) {
        record = [
            ['Voltage', React.createElement(FormattedUnit, { value: packet.mVoltage, unit: 'V' })],
            ['Ampere', React.createElement(FormattedUnit, { value: packet.mAmpere, unit: 'A' })],
            ['Watt', React.createElement(FormattedUnit, { value: packet.mWatt, unit: 'W' })],
            ['A·h', React.createElement(FormattedUnit, { value: packet.mAh, unit: 'A\u00B7h' }), React.createElement(Command, { onClick: CommandSet.resetAh.bind(null, type) }, "Reset")],
            ['W·h', React.createElement(FormattedUnit, { value: packet.mWh, unit: 'W\u00B7h' }), React.createElement(Command, { onClick: CommandSet.resetWh.bind(null, type) }, "Reset")],
            [CO2Name, React.createElement(FormattedUnit, { value: getCO2(packet.mWh), unit: 'g' })],
            ['USB D-', React.createElement(FormattedUnit, { value: packet.dataN, unit: 'V' })],
            ['USB D+', React.createElement(FormattedUnit, { value: packet.dataP, unit: 'V' })],
            ['Temperature', React.createElement(FormattedTemperature, { value: packet.temperature })],
            ['Duration', packet.duration, React.createElement(Command, { onClick: CommandSet.resetDuration.bind(null, type) }, "Reset")],
            ['Backlight Time', React.createElement(FormattedBacklightTime, { time: packet.backlightTime })],
        ];
    }
    else {
        return React.createElement("p", null, "Not connected to device.");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: 'ml-2 justify-content-center' },
            React.createElement(Report, { record: record })),
        React.createElement(Row, { className: 'ml-2 justify-content-center' },
            React.createElement(Toolbar, { type: type }))));
};
const Command = (props) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(sendCommand(props.onClick()));
    };
    return (React.createElement(Button, { color: 'link', size: 'sm', className: locals.btn, onClick: handleClick }, props.children));
};
const SetupPriceCommand = ({ type, value }) => {
    const onClick = () => {
        const price = prompt('Setup Price (0 to 999.99)', value, 0, 1000);
        if (price === undefined) {
            alert(`input unexpected (0 to 999.99)`);
            return;
        }
        console.log(price);
        return CommandSet.setPrice(type, _.toFinite(price * 100));
    };
    return React.createElement(Command, { onClick: onClick }, "Setup");
};
const SetupBacklightTimeCommand = ({ type, value }) => {
    const onClick = () => {
        const time = prompt('Setup Backlight Time (0 to 60)', value, 0, 60.01);
        if (time === undefined) {
            alert(`input unexpected (0 to 60)`);
            return;
        }
        return CommandSet.setBacklightTime(type, _.toFinite(time));
    };
    return React.createElement(Command, { onClick: onClick }, "Setup");
};
const FormattedTemperature = ({ value }) => (React.createElement("span", null,
    React.createElement("span", null,
        value,
        " \u2103"),
    ", ",
    React.createElement("span", null,
        (value * 9) / 5 + 32,
        " \u2109")));
const FormattedBacklightTime = ({ time }) => {
    if (time === 0) {
        return React.createElement("span", null, "Normally Closed");
    }
    else if (time === 60) {
        return React.createElement("span", null, "Normally Open");
    }
    else {
        return React.createElement("span", null,
            time,
            " sec");
    }
};
function getCO2(wh) {
    return wh * 0.997;
}
function prompt(message, defaultValue, minValue, maxValue) {
    const returns = globalThis.prompt(message, String(defaultValue));
    const price = Number.parseFloat(returns !== null && returns !== void 0 ? returns : '-1');
    if (!_.inRange(price, minValue, maxValue)) {
        return;
    }
    return price;
}
